import { Group } from '@bpmn-io/properties-panel'
import { FormProps } from './FormProps'

const LOW_PRIORITY = 500

export default class FormPropertiesProvider {
  constructor(propertiesPanel, injector) {
    propertiesPanel.registerProvider(LOW_PRIORITY, this)

    this._injector = injector
  }

  getGroups(element) {
    return (groups) => {
      const targetId = 'CamundaPlatform__Form'

      const index = groups.findIndex((item) => item.id === targetId)

      if (index !== -1) {
        groups.splice(index, 1, FormGroup(element, this._injector))
      }

      return groups.filter((group) => group !== null)
    }
  }
}

FormPropertiesProvider.$inject = ['propertiesPanel', 'injector'] // ovde je moglo i samo 'translate' i onda gore u kodu u 10. liniji this._translate = translate ... ali dobro sta god... retardi

function FormGroup(element, injector) {
  const translate = injector.get('translate')
  const group = {
    label: translate('Forms'),
    id: 'CamundaPlatform__Form',
    component: Group,
    entries: [...FormProps({ element })],
  }

  if (group.entries.length) {
    return group
  }

  return null
}
